export default __webpack_public_path__ + "static/media/Slider image 01.b4bc964e.PNG";